<template>
  <div class="vue-wrapper">
    <!--TheLoader :active="loading"/-->
    <div class="content-container flex-row">
      <!-- Scroll Menu -->
      <div class="sidebar left fixed subnav show-for-large">
        <div class="fixed-container">
          <scrollactive active-class="active" :highlightFirstItem="true" :offset="106" :duration="500" :modifyUrl="false" bezier-easing-value="0.455,0.03,0.515,0.955">
            <ul>
              <li><a href="#kunde-kontrakt-edit-section-0" class="scrollactive-item active" :class="{'error': sectionErrors.hasOwnProperty('kunde-kontrakt-edit-section-0')}">Innstillinger <span class="count" v-if="sectionErrors.hasOwnProperty('kunde-kontrakt-edit-section-0')">{{sectionErrors['kunde-kontrakt-edit-section-0']}}</span></a></li>
              <li><a href="#kunde-kontrakt-edit-section-1" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('kunde-kontrakt-edit-section-1')}">Satser <span class="count" v-if="sectionErrors.hasOwnProperty('kunde-kontrakt-edit-section-1')">{{sectionErrors['kunde-kontrakt-edit-section-1']}}</span></a></li>
              <li><a href="#kunde-kontrakt-edit-section-2" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('kunde-kontrakt-edit-section-2')}">Finders fee <span class="count" v-if="sectionErrors.hasOwnProperty('kunde-kontrakt-edit-section-2')">{{sectionErrors['kunde-kontrakt-edit-section-2']}}</span></a></li>
              <li><a href="#kunde-kontrakt-edit-section-3" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('kunde-kontrakt-edit-section-3')}">Legitimasjon <span class="count" v-if="sectionErrors.hasOwnProperty('kunde-kontrakt-edit-section-3')">{{sectionErrors['kunde-kontrakt-edit-section-3']}}</span></a></li>
              <li><a href="#kunde-kontrakt-edit-section-4" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('kunde-kontrakt-edit-section-4')}">Reise <span class="count" v-if="sectionErrors.hasOwnProperty('kunde-kontrakt-edit-section-4')">{{sectionErrors['kunde-kontrakt-edit-section-4']}}</span></a></li>
            </ul>
          </scrollactive>
        </div>
      </div>

      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">

          <div class="scroll-section" id="kunde-kontrakt-edit-section-0">
            <h2>Innstillinger</h2>

            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <TheSelectInput v-model="form.Avdelingsid" containerClassName="cell large-6" label="Avdeling" name="Avdelingsid" required v-validate="'required'" data-vv-validate-on="input" :items="instillinger.avdeling" :disabled="true"/>
                <TheSelectInput v-model="form.Kontrakttype" containerClassName="cell large-6" label="Kontrakttype" name="Kontrakttype" required v-validate="'required'" data-vv-validate-on="input" :items="instillinger.kontrakttype"/>
                <TheTextInput :value="kontrakt.Kontraktnr"  containerClassName="cell large-6" label="Kontraktnummer" disabled/>
                <TheSelectInput v-model="form.Mottaker" containerClassName="cell large-6" label="Kontraktansvarlig" name="Mottaker" required v-validate="'required'" data-vv-validate-on="input" :items="instillinger.mottaker"/>

                <TheTextInput v-model.trim="form.Kontraktinfo"  containerClassName="cell large-12" label="Kontraktinfo (vil vises på bankoverføring til selger)" name="Kontraktinfo" maxlength="34" v-validate="'max:34'"/>
                <TheTextInput v-model="form.Kontonummer"  containerClassName="cell large-12" label="Kontonummer" name="Kontonummer" v-validate="'min:11|max:11|kundeKontonrValidation'"/>
                <TheSwitchInput v-model="form.GodkjendtForInternett" containerClassName="cell" labelTrue="Synlig for selger" labelFalse="Ikke synlig for selger" trueValue="T" falseValue="F"/>

                <TheTextArea v-model.trim="form.Anmerkning" containerClassName="cell large-12" label="Anmerkning (synlig for kunde)" placeholder="Anmerkning…" name="Anmerkning" :rows="5" maxlength="2000" v-validate="'max:2000'"/>
              </div>
            </fieldset>
          </div>

          <div class="scroll-section" id="kunde-kontrakt-edit-section-1">
            <h2>Satser</h2>

            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <TheDecimalInput containerClassName="cell large-6" symbol="%" label="Salær" name="Salar" v-model.trim="form.Salar" maxlength="10" v-validate="'max:10|decimal'"/>
                <TheDecimalInput containerClassName="cell large-6" symbol="%" label="Forsikring" name="Forsikring" v-model.trim="form.Forsikring" maxlength="10" v-validate="'max:10|decimal'"/>
                <TheDecimalInput containerClassName="cell large-6" label="Forskudd" name="Forskudd" v-model.trim="form.Forskudd" maxlength="10" v-validate="'max:10|decimal'"/>
                <TheDecimalInput containerClassName="cell large-6" label="A konto" name="Akonto" v-model.trim="form.Akonto" maxlength="10" v-validate="'max:10|decimal'"/>
              </div>
            </fieldset>
          </div>

          <div class="scroll-section" id="kunde-kontrakt-edit-section-2">
            <h2>Finders fee</h2>

            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <TheIntegerInput containerClassName="cell large-4" symbol="%" label="Sats" name="FindersFee" v-model.trim="form.FindersFee" maxlength="10" v-validate="'max:10|integer'"/>

                <TheAutoCompleteInput containerClassName="cell large-8" v-model.trim="form.Formidler" :disabled="isFormidlerDisabled" :placeholder="'Navn, e-post...'" :label="'Mottaker'" :onInputCallback="onKundeSearchInput" :onSelectCallback="onKundeSearchSelected" :onResetCallback="onKundeSearchReset" :onCreateCallback="openKundeCardCreateModal" :debounce="500" :minquery="2">
                  <div slot="item" slot-scope="props">
                    <strong>{{props.item.Kundenr}}</strong> {{props.item.full_name}}
                  </div>
                </TheAutoCompleteInput>

                <!-- Hidden -->
                <!--TheTextInput containerClassName="cell large-4" label="Kundenr" id="FindersFeeMottaker" name="FindersFeeMottaker" v-model.trim="form.FindersFeeMottaker" :value="form.FindersFeeMottaker" disabled/-->

                <TheTextInput containerClassName="cell large-12" label="Beskrivelse" name="FormidlingTekst" v-model.trim="form.FormidlingTekst" maxlength="100" v-validate="'max:100'"/>
              </div>
            </fieldset>
          </div>

          <div class="scroll-section" id="kunde-kontrakt-edit-section-3">
            <h2>Legitimasjon</h2>
            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <div class="cell large-6">
                  <label for="Legtype">Legitimasjonstype</label>
                  <div class="select-container" :class="{ 'form-error': errors.has('Legtype') }">
                    <select id="Legtype" name="Legtype" v-model="form.Legtype" @change="$validator.validate('Legitimert'); form.Legitimert = false;">
                      <option v-for="option in instillinger.legitimasjon" v-bind:value="option.key" v-bind:key="option.key">{{option.val}}</option>
                    </select>
                    <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
                    <span class="form-error-label" v-if="errors.has('Legtype')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('Legtype')}}
                    </span>
                  </div>
                </div>

                <div class="cell small-12 medium-6">
                  <label>Legitimert <span v-if="form.Legtype">*</span></label>
                  <div class="radio-button-container" :class="{ 'form-error': errors.has('Legitimert') }">
                    <ul>
                      <li><input type="radio" :disabled="!form.Legtype" v-model="form.Legitimert" v-bind:value="false" name="Legitimert" id="ikke-legitimert" v-validate="{ included: form.Legtype ? ['true', true] : [] }"> <label for="ikke-legitimert">Nei</label></li>
                      <li><input type="radio" :disabled="!form.Legtype" v-model="form.Legitimert" v-bind:value="true" name="Legitimert" id="legitimert" checked> <label for="legitimert">Ja</label></li>
                    </ul>
                  </div>
                  <div class="cell small-12 large-12 medium-12" style="margin-top: -1.3rem;">
                    <div class="input-container" :class="{ 'form-error': errors.has('Legitimert') }">
                      <span class="form-error-label" v-if="errors.has('Legitimert')">
                        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                        Vennligst bekreft legitimasjonen
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="scroll-section" id="kunde-kontrakt-edit-section-4">
            <h2>Reise</h2>
            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-12">
                  <label>Reise</label>
                  <div class="radio-button-container" :class="{ 'form-error': errors.has('Reise') }">
                    <ul>
                      <li><input type="radio" v-model="form.Reise" v-bind:value="false" name="Reise" id="ikke-reise" > <label for="ikke-reise">Nei</label></li>
                      <li><input type="radio" v-model="form.Reise" v-bind:value="true" name="Reise" id="reise" checked> <label for="reise">Ja</label></li>
                    </ul>
                    <span class="form-error-label" v-if="errors.has('Reise')" style="position: relative; bottom: -0.5rem">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      Vennligst bekreft legitimasjonen
                    </span>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import KontraktService from '@/services/KontraktService'
import KundeService from '@/services/KundeService'
import TheAutoCompleteInput from '../Inputs/TheAutoCompleteInput'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktForm',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInput
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      form: {},
      sectionErrors: {},
      instillinger: {
        mottaker: [],
        avdeling: [],
        kontrakttype: [],
        legitimasjon: []
      },
      updateObjektSalar: false,
      loading: false
    }
  },
  mounted () {
    // Listen to submit form event from parent - cus button is in parent
    bus.$on('kontrakt-form-submit', () => this.handleSubmit())
    bus.$on('kunde_form_saved', (data) => this.onKundeCreated(data))
    bus.$on('kunde_search_found', (data) => this.onKundeCreated(data))
  },
  created () {
    // Must turn off the event listener in case it is already there...
    bus.$off('kontrakt-form-submit')
    bus.$off('kunde_form_saved')
    bus.$off('kunde_search_found')

    // Add the kunde kontonummer unique rule to our validator
    this.$validator.extend('kundeKontonrValidation', {
      validate: this.kontonrValidation,
      getMessage: (field, params, data) => data ? data.message : 'Virker som at Kontonummer ikke er gyldig'
    })

    // Set form not submittable
    this.setFormLoading(true)

    // Make the form object
    this.makeFormItem()

    // Load data needed in the form
    this.fetch()
  },
  computed: {
    isFormidlerDisabled: function () {
      return this._.toInteger(this.form.FindersFee) < 1
    }
  },
  watch: {
    'errors.items': function () {
      let vm = this
      let jq = window.jQuery

      // console.log(this.errors.items)
      setTimeout(() => {
        // Reset errors
        vm.sectionErrors = {}

        if (jq('.form-error').length) {
          jq('.form-error').each(function () {
            let section = jq(this).closest('.scroll-section')

            vm.sectionErrors[section.attr('id')] = jq('.form-error', section).length
          })
        }
      })
    },
    isFormidlerDisabled: function (isDisabled) {
      if (isDisabled) {
        this.form.Formidler = ''
        this.form.FindersFeeMottaker = null
      } else {
        if (this.kontrakt.FindersFeeMottaker) {
          this.form.FindersFeeMottaker = this.kontrakt.FindersFeeMottaker
        }
        if (this.kontrakt.Formidler) {
          this.form.Formidler = this.kontrakt.Formidler
        }
      }
    }
  },
  methods: {
    onKundeSearchReset: function () {
      this.form.Formidler = null
      this.form.FindersFeeMottaker = null
    },
    onKundeSearchInput: function (query) {
      return KundeService.search(query)
    },
    onKundeSearchSelected: function (item) {
      if (item) {
        this.form.Formidler = item.full_name || ''
        this.form.FindersFeeMottaker = item.Kundenr || null
      }
    },
    onKundeCreated: function (data) {
      this.form.Formidler = data.full_name || ''
      this.form.FindersFeeMottaker = data.Kundenr || null

      this.$validator.validate('Formidler')
      // this.$validator.validate('FindersFeeMottaker')

      this.closeModal()
    },
    openKundeCardCreateModal: function () {
      this.openModal('kunde-card-create-modal')
    },
    makeFormItem: function () {
      let defaults = {
        Mottaker: null,
        Avdelingsid: null,
        Kontrakttype: null,
        Legtype: 0,
        Legitimert: false,
        Avsluttet: 'F',
        FindersFeeMottaker: null,
        Reise: false
      }

      // Apply default values
      this.$helpers.setObjectValues(defaults, this.kontrakt)

      // Clone kontrakt to the form object
      this.form = this._.cloneDeep(this.kontrakt)
    },
    fetch: function () {
      this.loading = true

      // Add a temp item in all dropdowns, where it show that it is loading...
      this.instillinger.mottaker.unshift({key: this.form.Mottaker, val: 'Laster...'})
      this.instillinger.avdeling.unshift({key: this.form.Avdelingsid, val: 'Laster...'})
      this.instillinger.kontrakttype.unshift({key: this.form.Kontrakttype, val: 'Laster...'})
      this.instillinger.legitimasjon.unshift({key: this.form.Legtype, val: 'Laster...'})

      KontraktService.loadFormDropdowns()
        .then((data) => {
          this.instillinger.mottaker = data.bruker
          this.instillinger.mottaker.unshift({key: null, val: 'Velg kontraktansvarlig', disabled: true})

          this.instillinger.avdeling = data.avdeling
          this.instillinger.avdeling.unshift({key: null, val: 'Velg avdeling', disabled: true})

          this.instillinger.kontrakttype = data.kontrakttype
          this.instillinger.kontrakttype.unshift({key: null, val: 'Velg kontrakttype', disabled: true})

          this.instillinger.legitimasjon = data.legitimasjon
          this.instillinger.legitimasjon.unshift({key: 0, val: 'Velg legitimasjonstype'})
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.loading = false

          // Now submittable again
          this.setFormLoading(false)
        })
    },
    showSalarChangedConfirm: function () {
      const vm = this

      this.openConfirm(
        'Salær er endret',
        'Vil du også endre alle objekters salær?',
        'Ja, oppdater objekter også',
        'Nei',
        function () {
          vm.updateObjektSalar = true
          vm.closeModal()
          vm.save()
        },
        function () {
          vm.updateObjektSalar = false
          vm.closeModal()
          vm.save()
        }
      )
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            if (Number(this.form.Salar) !== Number(this.kontrakt.Salar)) {
              this.showSalarChangedConfirm()
            } else {
              this.save()
            }
          }
        })
    },

    save: function () {
      const post = this._.clone(this.form)
      post.updateObjektSalar = !!this.updateObjektSalar

      this.setFormProcessing(true)

      // No errors, so try to save
      KundeService.saveKundeKontrakt(this.kontrakt.Kundenr, this.kontrakt.Kontraktnr, post)
        .then((response) => {
          this.$helpers.showSuccessAlert('Kontrakt er lagret')

          // Handle update of kontrakt in KundeCard
          bus.$emit('kunde-kontrakt-updated', response.data)

          setTimeout(this.makeFormItem, 100)

          this.$emit('switchKontraktView', false)
        })
        .catch((error) => {
          // Put API errors into the error container
          this.$helpers.sendApiErrorsToValidator(error, this.errors)

          // Check if new errors appeared
          if (this.errors.any()) {
            this.$validator.resume()
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
          }
        })
        .then(() => {
          this.setFormProcessing(false)
          this.updateObjektSalar = false
        })
    },
    kontonrValidation: function (value) {
      return new Promise(resolve => {
        if (!value) {
          resolve({valid: false, data: {message: 'Kontonummer er påkrevd'}})
        } else if (value.length !== 11) {
          resolve({valid: false, data: {message: 'Kontonummeret må bestå av 11 siffer'}})
        } else if (this.kunde.Landkode === 'NO') {
          // Check modulus 11
          if (!this.checkModulus11(value)) {
            resolve({valid: false, data: {message: 'Kontonummeret er ikke gyldig'}})
          } else {
            resolve({valid: true})
          }
        } else {
          resolve({valid: true})
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktForm.vue